import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className='min-h-screen flex items-center justify-center bg-background'>
        <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-primary'></div>
      </div>
    );
  }

  // Redirect to login if not authenticated, preserve intended destination
  if (!loading && !isAuthenticated) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  // Check role-based access if required
  if (requiredRole && user?.role?.name !== requiredRole) {
    // For now, allow access but could show unauthorized page
    return children;
  }

  return children;
};

export default ProtectedRoute;
